
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[guild]/claim-poap/[fancyId]",
      function () {
        return require("private-next-pages/[guild]/claim-poap/[fancyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[guild]/claim-poap/[fancyId]"])
      });
    }
  